import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import Sample from "./Sample";

var SampleMap =
/*#__PURE__*/
function () {
  function SampleMap(context, sample_map) {
    _classCallCheck(this, SampleMap);

    this.context = context;
    this.input_map = sample_map;
    this.samples = {};
    this.loaded = false;
  }

  _createClass(SampleMap, [{
    key: "load",
    value: function load() {
      var _this = this;

      var sampleLoad = [];
      this.input_map.forEach(function (sample) {
        var newsample = new Sample(_this.context);
        newsample.load(sample.src).then(function () {
          _this.samples[sample.value] = Object.assign(sample, {
            sample: newsample
          });
        });
        sampleLoad.push(newsample);
      });
      return Promise.all(sampleLoad);
    }
  }]);

  return SampleMap;
}();

export { SampleMap as default };